export default __webpack_public_path__ + "static/media/f_section.97eed5fb.svg";